var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBookingLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 60,
    viewBox: "0 0 51 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.5 0C28.3006 2.82645 31.2486 5.80992 33.9017 8.79339L30.9538 13.0331V13.1901L39.2081 17.1157L44.8093 13.0331L41.2717 9.10744V8.79339C44.6619 6.28099 47.6098 3.7686 51 1.2562L49.3786 19H1.47399L0 1.41322C3.39017 3.7686 6.33815 6.28099 9.72832 8.95041V9.26446L6.33815 13.0331L11.9393 17.1157L20.1936 13.1901V13.0331L17.0983 8.79339C19.7514 5.80992 22.8468 2.82645 25.5 0Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M49 22L48.566 27.918H31.2075V48.1639H39.7421C41.6226 48.1639 43.6478 45.9836 43.2138 44.582C42.7799 42.5574 41.044 41.1557 39.4528 40.2213C39.7421 40.2213 45.5283 35.5492 48.2767 33.6803C48.1321 34.9262 46.2516 51.4344 46.2516 51.7459L26.1447 60H25.8553L5.74843 51.7459C5.74843 51.4344 3.72327 34.9262 3.72327 33.6803C6.4717 35.7049 12.2579 40.2213 12.5472 40.2213C10.956 41.3115 9.22013 42.5574 8.78616 44.582C8.3522 45.9836 10.3774 48.1639 12.2579 48.1639H20.7925V27.918H3.43396L3 22H49Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBookingLogo);
export default __webpack_public_path__ + "static/media/booking-logo.4be7808941c79ffdf90f1062aa0870e5.svg";
export { ForwardRef as ReactComponent };